import * as yup from "yup";

import { EMAIL_REGEX } from "../constants";

export const LoginSchema = yup.object({
  email: yup
    .string()
    .email(`Please enter a valid email`)
    .required('Email is required')
    .test('EmailVerification', `Please enter a valid email`, (val) => (EMAIL_REGEX.test(val)), ),

    // password: yup
    // .string()
    // .required('Password is required')
    // .min(10, `Password should be at least 10 characters`)
    // .test('PasswordValidation',
    //   `Password should contain <ul><li> Length should be 10,</li>
    //   <li> must contain at least 1 lowercase letter,</li>
    //   <li> must contain at least 1 uppercase letter,</li>
    //   <li> and 1 number</li>
    //   <li> Can contain special character.</li></ul>`,
    //   (val) => PASSWORD_REGEX.test(val)
    // ),
  password: yup
  .string()
  //.required('Password is required')
  //.min(10, 'Password should be at least 10 characters')
  // .test(
  //   'PasswordValidation',
  //   'Password does not meet requirements',
  //   (val) => PASSWORD_REGEX.test(val)
  // ),
});
